import PodcastPoster from "@elements/Card/Thumbnail/PodcastPoster";
import VideoPoster from "@elements/Card/Thumbnail/VideoPoster";
import Date from "@elements/Typography/Date";
import { twMerge } from "tailwind-merge";

export type ThumbnailProps<T> = T & {
  id?: string;
  description: string;
  name: string;
  published_at: string;
  nowPlaying: boolean;
  thumbnail: string;
  poster?: string;
  formattedTime?: string | undefined;
  variant: "video" | "podcast" | "portrait-video";
  handleOnClickThumbnail: (props: T) => void;
  customCardStyles?: string;
  isHideDateTime?: boolean;
  isDark?: boolean;
  videoPosterDimensions?: string;
};

export default function ThumbnailCard<T>(props: ThumbnailProps<T>) {
  const {
    name,
    published_at,
    nowPlaying,
    thumbnail,
    poster,
    formattedTime,
    variant,
    handleOnClickThumbnail,
    customCardStyles,
    isHideDateTime,
    videoPosterDimensions,
    isDark,
    id,
  } = props;

  const isVideoVariant = variant === "video";
  const isPortraitVideoVariant = variant === "portrait-video";

  return (
    <div
      id={`thumbnail-card-${id}`}
      className={twMerge("flex py-2 lg:py-4 gap-4", customCardStyles)}
      data-testid="thumbnail-card"
    >
      <button
        type="button"
        onClick={() => {
          handleOnClickThumbnail(props);
        }}
        className={twMerge(isVideoVariant && "inline-flex")}
      >
        {(isVideoVariant || isPortraitVideoVariant) && (
          <VideoPoster
            videoPosterDimensions={videoPosterDimensions}
            nowPlaying={nowPlaying}
            src={isPortraitVideoVariant ? (poster ?? thumbnail) : thumbnail}
            formattedTime={formattedTime}
            objectFit={isPortraitVideoVariant ? "cover" : "contain"}
          />
        )}
        {variant === "podcast" && <PodcastPoster src={thumbnail} />}
      </button>

      <button
        type="button"
        className="flex flex-col w-full cursor-pointer"
        onClick={() => {
          handleOnClickThumbnail(props);
        }}
      >
        <h4
          className={twMerge(
            "text-[16px] font-secondary text-black-200 leading-xs text-start break-all",
            variant === "podcast" && "font-semibold",
            isVideoVariant && isDark ? "text-[#FAFAFA]" : "text-gray-100",
          )}
          data-testid="name"
        >
          {name}
        </h4>
        {isHideDateTime ? null : (
          <div
            className={twMerge(
              "flex flex-col-reverse items-end justify-between w-full lg:items-center lg:flex-row",
              (isVideoVariant || isPortraitVideoVariant) && "items-start",
            )}
          >
            <Date
              className={twMerge(isPortraitVideoVariant && "text-gray-800")}
            >
              {published_at}
            </Date>
          </div>
        )}
      </button>
    </div>
  );
}
